import { CommentsCollection } from 'models/CommentsCollection';
import CommentModel from 'models/CommentModel';
import { repository as loadRepository } from 'repositories/loadCommentsAsync';
import shoutboxRepository from '@ui/shoutbox/repository';
import exposeSharedComment from '@ui/comments/expose-shared-comment';
import saveCommentsAsync from 'repositories/saveCommentsAsync';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

const saveRepository = new saveCommentsAsync();

const elements = {
  config: '.c-comments-config',
};

class CommentsService {
  constructor() {
    this.shoutboxmode = false;
    this.discussion = {
      mode: false,
    }

    const $configuration = $(elements.config);
    if ($configuration.length) {
      this.shoutboxmode = $configuration.data('shoutbox-mode');
      this.discussion = {
        mode: $configuration.data('discussion-mode'),
        thread: $configuration.data('discussion-thread'),
      }
    }

    this.visibleCommentsCollection = new CommentsCollection();
    this.bufferCommentsCollection = new CommentsCollection();
  }
  updateDeletedComment(flatModel) {
    const model = CommentModel.fromJSON(flatModel);

    this.visibleCommentsCollection.update(model);
    this.bufferCommentsCollection.update(model);
  }
  getVisibleCommentsCollection() {
    return this.visibleCommentsCollection;
  }
  getBufferCommentsCollection() {
    return this.bufferCommentsCollection;
  }
  getBufferredBaseComments() {
    const oldComments = this.visibleCommentsCollection.get('comments');
    const newComments = this.bufferCommentsCollection.get('comments');

    return _.differenceBy(newComments, oldComments, (model) => model.get('id'));
  }
  isShoutboxMode() {
      return this.shoutboxmode;
  }
  isDiscussionMode() {
    return this.discussion.mode;
  }
  getDiscussionThread() {
    return this.discussion.thread;
  }
  getShoutboxParams() {
      const collection = this.visibleCommentsCollection;
      return collection.get('shoutbox');
  }
  setShoutboxParams(filters) {
      const collection = this.visibleCommentsCollection;
      const init = (typeof collection.get('shoutbox') == 'undefined') ? {} : collection.get('shoutbox');
      let assign = Object.assign(init, filters);

      for (let i in assign) {
          if (!assign[i]) {
              delete assign[i];
          }
      }

      if (assign.page == 1) {
          assign.last = moment().unix();
      }

      collection.set('shoutbox', assign);
      return collection.get('shoutbox');
  };
  getShoutboxBaseComments() {
      const comments = this.visibleCommentsCollection.get('comments');
      const ids = comments.map((comment) => {
          return comment.get('id');
      })

      return ids;
  }
  loadFromBuffer(model) {
    model.set('isNew', true);
    // Add element as a first in visible collection
    this.visibleCommentsCollection
      .get('comments')
      .unshift(model);
    this.visibleCommentsCollection.fireEvent('cleanedPendingRepliesCounter');
  }
  loadBaseCommentFromBufferById(id) {
    const model = this.bufferCommentsCollection.findById(id);

    // Add element as a first in visible collection
    this.visibleCommentsCollection
      .get('comments')
      .unshift(model);
  }
  updateBannedUsersFlag({ username, isUserBanned, banInfo }) {
    const updateUserBannedFlag = (model) => {
      if (model.get('username') === username) {
        model.set('isUserBanned', isUserBanned);
        if (banInfo) {
          model.set('banInfo', banInfo);
        }
      }
    };
    this.visibleCommentsCollection.get('comments')
      .forEach(updateUserBannedFlag);
    this.bufferCommentsCollection.get('comments')
      .forEach(updateUserBannedFlag);
  }
  cancelBanUsersFlag({ username }) {
    this.visibleCommentsCollection.get('comments').forEach((model) => {
      if (model.get('username') !== username) {
        return;
      }
      const bufferedModel = this.bufferCommentsCollection
        .findById(model.get('id'));

      if (!bufferedModel) {
        return;
      }

      const banInfo = (bufferedModel.get('banInfo'))
       ? bufferedModel.get('banInfo')
       : null;

      model.set('banInfo', banInfo);
    });
  }
  loadRepliesFromBuffer(modelId) {
    const oldModel = this.visibleCommentsCollection.findById(modelId);
    const updatedModel = this.bufferCommentsCollection.findById(modelId);

    if (updatedModel) {
      oldModel.set('replies', updatedModel.get('replies'));
    }
  }
  init() {
    let criterion = 'date';
    let repository = loadRepository;

    if (this.isShoutboxMode()) {
        repository = shoutboxRepository;
        criterion = this.visibleCommentsCollection.get('shoutbox');
    }

    repository.load(criterion)
      .then((data) => {
          this.visibleCommentsCollection.fromJSON(data.comments);
          this.bufferCommentsCollection.fromJSON(data.comments);

          this.visibleCommentsCollection.set('filter', 'date');

          this.visibleCommentsCollection.fireEvent('loaded');
          exposeSharedComment.init(this.visibleCommentsCollection);
          document.dispatchEvent(new CustomEvent('CommentsInitialised'));
      });

      $(window).on('hashchange', () => {
        if (exposeSharedComment.checkIfIsCommentShared()) {
          exposeSharedComment.init(this.visibleCommentsCollection);
        }
      });
  }
  updateCollection(successCallback) {

    const filter = this.visibleCommentsCollection.get('filter');
    const shoutbox = this.visibleCommentsCollection.get('shoutbox');

    let repository = loadRepository;
    let params = filter;

    if (this.isShoutboxMode()) {
        repository = shoutboxRepository;
        params = shoutbox;
    }

    repository.load(params).then((data) => {

        if (successCallback) {
          successCallback(data);
        }
        this.visibleCommentsCollection.fromJSON(data.comments);

        if (this.isShoutboxMode()) {
          this.bufferCommentsCollection.fromJSON(data.comments);
        }

        this.visibleCommentsCollection.fireEvent('loaded');

    }, (error) => {
        throw error;
    });
  }
  labelNewComments({ oldComments, newComments }) {
    const flattenArr = arr =>
        arr.reduce((comp, v) => {
          comp.push(v.get('id'), ..._.map(v.get('replies'), (comment) => comment.get('id')));
          return comp;
        }, []);

    const flattenArrRaw = arr =>
        arr.reduce((comp, v) => {
          comp.push(v.id, ..._.map(v.replies, 'id'));
          return comp;
        }, []);

    const oldCommentsArr = flattenArr(oldComments);
    const newCommentsArr = flattenArrRaw(newComments);

    const newCommentRange = moment.range(oldComments[0].get('createdAt'), null);

    if (oldCommentsArr.length === newCommentsArr.length) {
      return null;
    }

    const labels = {
      base: 0,
      replies: {},
    };

    const currentCommentRange = oldComments.slice(0);

    newComments.forEach((newModelObject) => {
      const createdAt = moment(newModelObject.createdAt)
      if (newCommentRange.contains(createdAt, { exclusive: true })) {
        labels.base++;
      }
    });

    const mapNewCommentsRepliesCountSubtraction = (comment) => {
      const id = comment.id;
      for (const index in currentCommentRange) {
        const currentComment = currentCommentRange[index];
        if (currentComment.get('id') === id) {
          const subtract = comment.replies.length - currentComment.get('replies').length;
          if (subtract > 0) {
            labels.replies[id] = subtract;
          }
          currentCommentRange.splice(index, 1);
        }
      }
    };

    newComments.forEach(mapNewCommentsRepliesCountSubtraction);

    return labels;
  }
  checkLive() {
    const filter = this.visibleCommentsCollection.get('filter');
    loadRepository.load(filter).then((data) => {
      const labels = this.labelNewComments({
        oldComments: this.visibleCommentsCollection.get('comments'),
        newComments: data.comments,
      });
      if (!_.isNull(labels)) {
        this.visibleCommentsCollection.updatePendingRepliesCounter(labels);
      }
      this.bufferCommentsCollection.fromJSON(data.comments);
    }, (error) => {
        throw error;
    });
  }
  addComment(item, successCallback) {
    saveRepository.save(item).then((data) => {
        const newCommentId = data.commentId;
        loadRepository.load().then((data) => {
            if (successCallback) {
              successCallback();
            }

            this.bufferCommentsCollection.fromJSON(data.comments);

            if (item.parentCommentId) {
              const parentModel = this.visibleCommentsCollection
                .findById(item.parentCommentId);

              if (_.isNil(parentModel)) {
                throw new Error(`There's no base comment`);
              } else {
                this.loadRepliesFromBuffer(item.parentCommentId);
                parentModel.fireEvent('added', newCommentId);
              }
            } else {
              this.loadBaseCommentFromBufferById(newCommentId);
              this.visibleCommentsCollection.fireEvent('added', newCommentId);
            }

        }, (error) => {
            throw error;
        });

    }, (error) => {
        throw error;
    });
  }
  isLiveEnabled() {
    const setting = `${this.isShoutboxMode() ? 'shoutbox' : 'article'}.comments.live.enabled`;
    return window.rmpl.get('public', setting);
  }
  getLiveRepositoryInterval() {
    const option = `${this.isShoutboxMode() ? 'shoutbox' : 'article'}.comments.live.interval_sec`;
    const setting = window.rmpl.get('public', option);
    const interval = isNaN(setting) ? 30 : Number(setting);

    return interval * 1000;
  }
  getMoreRenderStep() {
    return window.rmpl.get('article', 'comments.more.step');
  }
  getMoreRenderLimit() {
    return window.rmpl.get('article', 'comments.more.limit');
  }
}

const commentService = new CommentsService();

export default commentService;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/CommentService.js